import React, { PureComponent } from "react";
import { Link } from "react-router";
import ExpandImage from "../../../../containers/assets/icon_expand.svg";
import HelpIconButtonWithTooltipAndTypeformModal from "../../../typeform/HelpIconButtonWithTooltipAndTypeformModal";
import TypeformContent from "../../../typeform/TypeformContent";
import HorizontalBarChart from "../../../ceo/analysis/competitive/charts/horizontal-bar";
import VerticalBarChart from "../../../ceo/analysis/competitive/charts/vertical-bar";

class CompetitiveAnalysis extends PureComponent {
  getDataValue = (team_id, key) => {
    const { data } = this.props;

    if (!(team_id in data)) {
      return 0;
    }

    if (!(key in data[team_id])) {
      return 0;
    }

    let val = data[team_id][key];

    if (!val) {
      return 0;
    }

    return val;
  };

  get EarningPerShare() {
    const { teams } = this.props;
    let data = [];

    Object.keys(teams).forEach(team_id => {
      const team = teams[team_id];
      data.push({
        name: team,
        value: this.getDataValue(team_id, "Earnings Per Share")
      });
    });

    return data;
  }

  get SharePrice() {
    const { teams } = this.props;
    let data = [];

    Object.keys(teams).forEach(team_id => {
      const team = teams[team_id];
      data.push({
        name: team,
        value: this.getDataValue(team_id, "Share Price")
      });
    });

    return data;
  }

  get MarketShare() {
    const { teams, metrics } = this.props;
    let data = [];

    Object.keys(teams).forEach(team_id => {
      const team = teams[team_id];
      data.push({
        name: team,
        value:
          metrics[team_id] && metrics[team_id]["MarketShare"]
            ? metrics[team_id]["MarketShare"] * 100
            : 0
      });
    });

    return data;
  }

  get Revenues() {
    const { teams, metrics } = this.props;
    let data = [];

    Object.keys(teams).forEach(team_id => {
      const team = teams[team_id];
      data.push({
        name: team,
        value:
          metrics[team_id] && metrics[team_id]["Revenues"]
            ? metrics[team_id]["Revenues"] / 1000000
            : 0
      });
    });

    return data;
  }

  render() {
    const { activeRound, currentRound, roundInUrl } = this.props;
    let url = "/ceo/analysis/competitive";
    if (roundInUrl !== null && roundInUrl !== currentRound) {
      url = `/ceo/analysis/competitive?round=${roundInUrl}`;
    }

    return (
      <div className="container-analysis">
        <h3 className="semibold">
          Competitive Analysis
          <HelpIconButtonWithTooltipAndTypeformModal
            {...TypeformContent.COMPETITIVE_ANALYSIS}
          />
          <Link to={url} className="icon-zoom">
            <img src={ExpandImage} className="icon" alt="ExpandImage" />
          </Link>
        </h3>
        <div className="panel-dashboard-white bg-light-gray p-15 mt-30">
          {activeRound <= 4 && (
            <div className="row">
              <div className="col-md-6 no-padding col-xs-12">
                <HorizontalBarChart
                  suffix="%"
                  data={this.MarketShare}
                  barSize={20}
                />
                <div className="text-center" style={{ marginTop: "-20px" }}>
                  Market Share
                </div>
              </div>
              <div className="col-md-6 no-padding col-xs-12">
                <VerticalBarChart
                  prefix="$"
                  suffix="M"
                  precision={3}
                  data={this.Revenues}
                />
                <div className="text-center" style={{ marginTop: "-20px" }}>
                  Revenues
                </div>
              </div>
            </div>
          )}
          {activeRound > 4 && (
            <div className="row">
              <div className="col-md-6 no-padding col-xs-12">
                <HorizontalBarChart
                  prefix="$"
                  data={this.SharePrice}
                  barSize={20}
                />
                <div className="text-center" style={{ marginTop: "-20px" }}>
                  Share Price
                  <HelpIconButtonWithTooltipAndTypeformModal
                    iconSize="xs"
                    {...TypeformContent.STOCK_PRICE}
                  />
                </div>
              </div>
              <div className="col-md-6 no-padding col-xs-12">
                <VerticalBarChart prefix="$" data={this.EarningPerShare} />
                <div className="text-center" style={{ marginTop: "-20px" }}>
                  Earnings Per Share
                  <HelpIconButtonWithTooltipAndTypeformModal
                    iconSize="xs"
                    {...TypeformContent.EARNINGS_PER_SHARE}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default CompetitiveAnalysis;



// WEBPACK FOOTER //
// ./src/components/ceo/analysis/widgets/competitive-analysis.js